import '../styles/VehicleStatus.css';
import { vehicleStatusClass } from '../utils/helper';

const VehicleStatus = ({ status, className }) => {

    const { backgroundColor, color } = vehicleStatusClass(status);

    return (
        <div className={`vehicle_status ${className}`} style={{ backgroundColor, color }}>
            {status}
        </div>
    )
}

export default VehicleStatus